import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Main from "./pages/Main/Main";
import NotFound from "./pages/NotFound/NotFound";
import Policy from "./pages/Policy/Policy";
import Ratings from "./pages/Ratings/Ratings";
import Breadcrumbs from "./components/UI/Breadcrumbs/Breadcrumbs";
import Header from "./components/layout/Header/Header";
import Services from "./pages/ServicePages/ServicesMainPage/Services";
import Services1 from "./pages/ServicePages/Services1/Services1";
import Services2 from "./pages/ServicePages/Services2/Services2";
import Services3 from "./pages/ServicePages/Services3/Services3";
import Services4 from "./pages/ServicePages/Services4/Services4";
import Services5 from "./pages/ServicePages/Services5/Services5";
import Services6 from "./pages/ServicePages/Services6/Services6";
import Services7 from "./pages/ServicePages/Services7/Services7";
import ScrollToTop from "./types/ScrollToTop";
import Company from "./pages/About/Company/Company";
import Blog from "./pages/About/Blog/Blog";
import PostDetail from "./pages/About/PostDetail/PostDetail";
import ServicesVS from "./pages/ServicePages/ServicesVacancySub/ServicesVS";

function App() {
  return (
    <BrowserRouter>
      <Header />
      <Breadcrumbs />
      <ScrollToTop />
      <Routes>
        <Route path="/about/blog/post/:postId" element={<PostDetail />} />
        <Route path="*" element={<NotFound />} />
        <Route path="/" element={<Main />} />
        <Route path="/policy" element={<Policy />} />
        <Route path="/ratings" element={<Ratings />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/talkitout" element={<Services1 />} />
        <Route path="/services/careerconsulting" element={<Services2 />} />
        <Route path="/services/cvready" element={<Services3 />} />
        <Route path="/services/vs" element={<ServicesVS />} />
        <Route
          path="/services/supportduringthejobsearchsupport"
          element={<Services4 />}
        />
        <Route
          path="/services/supportduringtheprobationaryperiod"
          element={<Services5 />}
        />
        <Route
          path="/services/recruitmentofITspecialists"
          element={<Services6 />}
        />
        <Route
          path="/services/trainingofITrecruiters"
          element={<Services7 />}
        />
        <Route path="/about/blog" element={<Blog />} />
        <Route path="/about/company" element={<Company />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
